import * as yup from 'yup'

export const TitleValidation = yup.string()
